import { render, staticRenderFns } from "./antecedent-allergologie-personnel.html?vue&type=template&id=45bc90e9&scoped=true&external"
import script from "./antecedent-allergologie-personnel.js?vue&type=script&lang=js&external"
export * from "./antecedent-allergologie-personnel.js?vue&type=script&lang=js&external"
import style0 from "./antecedent-allergologie-personnel.scss?vue&type=style&index=0&id=45bc90e9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc90e9",
  null
  
)

export default component.exports